import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight, Mail } from 'lucide-react';
import './CTASection.css';

export const CTASection = () => {
  const reduced = useReducedMotion();

  return (
    <section className="cta-section">
      <div className="cta-glow" aria-hidden="true" />
      <motion.div
        className="cta-container"
        initial={{ opacity: 0, y: reduced ? 0 : 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: reduced ? 0.2 : 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <h2 className="cta-title">Ready to build your AI agent?</h2>
        <p className="cta-subtitle">
          Tell us what you need. We’ll scope it in 24 hours.
        </p>
        <div className="cta-buttons">
          <Link to="/contact" className="btn-primary">
            Book a Scoping Call <ArrowRight size={18} />
          </Link>
          <a href="mailto:sales@liceron.in" className="cta-email">
            <Mail size={16} /> sales@liceron.in
          </a>
        </div>
        <p className="cta-note">
          No commitment required · Response within 24 hours · Enterprise &amp; startup-friendly
        </p>
      </motion.div>
    </section>
  );
};
